import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {ScrollView, View, TextInput} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
import {BodyText} from 'src/Modules/CommonView';

import {HeaderText} from 'src/Modules/CommonView/Text';
import {ContinueButton, IconButton} from 'src/Modules/CommonView/Buttons';

import {updateDataAtPath} from '../Utils/fireUtils';
import {navigationRef} from 'src/Nav/navigationHelpers';
import useParams from 'src/Hooks/useParams';

const HuntPostCard = () => {
  const {width} = useWindowDimensionsSafe();

  const {handleConfirm = false} = useParams();
  const userId = useSelector((state) => state.user?.userId);
  const firstName = useSelector((state) => state.user?.info?.firstName);
  const lastName = useSelector((state) => state.user?.info?.lastName);
  const address = useSelector((state) => state.user?.info?.address || {});

  const {
    address1 = '',
    address2 = '',
    city = '',
    state = '',
    zip_code = '',
    fullName = `${firstName} ${lastName}`,
  } = address;

  const [userAddressInfo, setUserAddressInfo] = useState({
    address,
  });

  const handleInputChange = (updateData) => {
    setUserAddressInfo({...address, ...updateData});
    if (updateData) {
      const path = `users/${userId}/address`;
      console.log('updating user address data', {path, updateData});
      updateDataAtPath(path, updateData);
    }
  };

  return (
    <View style={{flex: 1, justifyContent: 'flex-end'}}>
      <View
        style={{
          minHeight: 550,
          backgroundColor: 'white',
          position: 'relative',
        }}>
        <IconButton
          handlePress={() => navigationRef.goBack(null)}
          left
          color={global?.color?.gray3}
          buttonStyle={{top: 30, zIndex: 1000}}
        />
        <ScrollView style={{flex: 1, backgroundColor: 'white'}}>
          <View
            style={{
              flex: 1,
              paddingVertical: 10,
              minHeight: 300,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}>
            <View
              style={{width: '100%', display: 'flex', alignItems: 'center'}}>
              <HeaderText
                text={'Your Post Card Address'}
                textStyle={{marginLeft: 5, textAlign: 'center'}}
                bodyStyle={{marginLeft: 10, width: '90%'}}
              />
              <BodyText
                text={`Your Name`}
                textStyle={{textAlign: 'left', width: '90%', fontSize: 12}}
              />
              <TextInput
                style={{
                  width: '90%',
                  height: 40,
                  borderColor: global?.color?.orange,
                  borderWidth: 1,
                  paddingBottom: 5,
                  borderRadius: 10,
                  paddingLeft: 10,
                }}
                allowFontScaling={false}
                textAlign={'left'}
                value={fullName}
                autoCorrect={false}
                underlineColorAndroid={'transparent'}
                onChangeText={(text) => handleInputChange({fullName: text})}
                blurOnSubmit
              />
              <BodyText
                text={`Address Line 1`}
                textStyle={{textAlign: 'left', width: '90%', fontSize: 12}}
              />
              <TextInput
                style={{
                  width: '90%',
                  height: 40,
                  borderColor: global?.color?.orange,
                  borderWidth: 1,
                  paddingBottom: 5,
                  borderRadius: 10,
                  paddingLeft: 10,
                }}
                allowFontScaling={false}
                textAlign={'left'}
                value={address1}
                autoCorrect={false}
                underlineColorAndroid={'transparent'}
                onChangeText={(text) => handleInputChange({address1: text})}
                blurOnSubmit
              />
              <BodyText
                text={`Address Line 2`}
                textStyle={{textAlign: 'left', width: '90%', fontSize: 12}}
              />
              <TextInput
                style={{
                  width: '90%',
                  height: 40,
                  borderColor: global?.color?.orange,
                  borderWidth: 1,
                  paddingBottom: 5,
                  borderRadius: 10,
                  paddingLeft: 10,
                }}
                allowFontScaling={false}
                textAlign={'left'}
                value={address2}
                autoCorrect={false}
                underlineColorAndroid={'transparent'}
                onChangeText={(text) => handleInputChange({address2: text})}
                blurOnSubmit
              />
              <BodyText
                text={`City`}
                textStyle={{textAlign: 'left', width: '90%', fontSize: 12}}
              />
              <TextInput
                style={{
                  width: '90%',
                  height: 40,
                  borderColor: global?.color?.orange,
                  borderWidth: 1,
                  paddingBottom: 5,
                  borderRadius: 10,
                  paddingLeft: 10,
                }}
                allowFontScaling={false}
                textAlign={'left'}
                value={city}
                autoCorrect={false}
                underlineColorAndroid={'transparent'}
                onChangeText={(text) => handleInputChange({city: text})}
                blurOnSubmit
              />
              <BodyText
                text={`State`}
                textStyle={{textAlign: 'left', width: '90%', fontSize: 12}}
              />
              <TextInput
                style={{
                  width: '90%',
                  height: 40,
                  borderColor: global?.color?.orange,
                  borderWidth: 1,
                  paddingBottom: 5,
                  borderRadius: 10,
                  paddingLeft: 10,
                }}
                allowFontScaling={false}
                textAlign={'left'}
                value={state}
                autoCorrect={false}
                underlineColorAndroid={'transparent'}
                onChangeText={(text) => handleInputChange({state: text})}
                blurOnSubmit
              />
              <BodyText
                text={`Zip Code`}
                textStyle={{textAlign: 'left', width: '90%', fontSize: 12}}
              />
              <TextInput
                style={{
                  width: '90%',
                  height: 40,
                  borderColor: global?.color?.orange,
                  borderWidth: 1,
                  paddingBottom: 5,
                  borderRadius: 10,
                  paddingLeft: 10,
                }}
                allowFontScaling={false}
                textAlign={'left'}
                value={zip_code}
                autoCorrect={false}
                underlineColorAndroid={'transparent'}
                onChangeText={(text) => handleInputChange({zip_code: text})}
                blurOnSubmit
              />
            </View>
            <ContinueButton
              containerStyle={{
                width: width - 60,
                marginTop: 10,
                marginHorizontal: 30,
              }}
              text={`Confirm & Send Post Card`}
              handlePress={() => handleConfirm(userAddressInfo)}
            />
            <View></View>
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default HuntPostCard;
